<template>
  <div class="invitation-send">
    <div class="invitation-send-content">
      <div class="invitation-field-item">
        <div class="invitation-title">预约展商：</div>
        <div class="invitation-exhibitor-info">
          <div class="left">
            <img class="img" :src="exhibitorInfo.logoImage || 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/tangjiu/113/invite-default-avatar.png'" alt="">
          </div>
          <div class="right">
            <div class="exhibitor-content">
              <div class="exhibitor-name">{{exhibitorInfo.name}}</div>
              <div class="site">{{exhibitorInfo.exhibitionBoothNumber}}</div>
              <div class="contact">
                <!-- <span class="name">徐丽</span> -->
                <!-- <span class="post">采购经理</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="invitation-field-item">
        <div class="invitation-title"><span class="require">*</span>洽谈方式：</div>
        <div class="invitation-field-content">
          <div class="invite-field" v-for="(address, index) in addressList" :key="address.code" @click="onChange(index)">
            <div class="field-radio" :class="{active: currentIndex === index}"></div>
            <div class="field-label">{{address.name}}</div>
          </div>
        </div>
      </div>

      <div class="invitation-field-item">
        <div class="invitation-title"><span class="require">*</span>洽谈时间：</div>
        <div class="invitation-field-content">

          <div class="invitation-date">
            <div class="invitation-date-item" @click="onDateClick">
              <div class="picker-inner">
                <span class="placeholder" v-if="!dateValue">请选择洽谈日期</span>
                <span class="date-value">{{dateValue}}</span>
                <span class="iconfont icon-a-126show_richeng"></span>
              </div>
            </div>
            <div class="invitation-date-item" @click="onPickerClick">
              <div class="picker-inner">
                <span class="placeholder" v-if="!timeRangeValue">请选择洽谈时间</span>
                <span class="date-value">{{timeRangeValue}}</span>
                <span class="iconfont icon-a-68show_shijianlishiji"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="invitation-field-item">
        <div class="invitation-title"><span class="require">*</span>洽谈主题：</div>
        <div class="invitation-field-content">
          <textarea v-model="theme" @input="onInput" class="textarea" name="theme" rows="5" placeholder="请输入您需要了解展商的相关需求" maxlength="200"></textarea>
        </div>
      </div>

      <div class="tip-section">
        <div class="tip-inner">
          <p class="tip-title">温馨提示：</p>
          <p class="tip-item">1、在您完成预约的1个工作日内，平台客服将与您联系，并确认相关洽谈事宜</p>
          <p class="tip-item">2、如有疑问，您可以联系平台客服：400-001-001</p>
        </div>
      </div>

      <div class="send-section">
        <div class="send-button" @click="onSend">发送预约</div>
        <!-- <div class="send-button success">完成预约</div> -->
      </div>
    </div>


    <van-popup v-model="showDatePicker" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        cancel-button-text="关闭"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="onCancel"
      >
        <template #title>
          <span class="picker-title">洽谈日期</span>
        </template>
      </van-datetime-picker>
    </van-popup>

    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        :defaultIndex="defaultIndex"
        cancel-button-text="关闭"
        @confirm="onPickerConfirm"
        @cancel="onPickerCancel"
      >
        <template #title>
          <span class="picker-title">洽谈时间</span>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
  import { mapGetters} from 'vuex'

  export default {
    data() {
      return {
        exhibitorId: "",
        exhibitorInfo: {},
        currentIndex: null,
        addressList:[
          { name: "在线洽谈", code: 'PENDING' },
				  { name: "第113届全国糖酒会洽谈专区", code:'APPROVE' }
        ],
        showDatePicker: false,
        currentDate: new Date(2025, 8, 2),
        minDate: new Date(2025, 8, 1),
        maxDate: new Date(2025, 8, 4),
        dateValue: "",
        defaultIndex: 0,
        showPicker: false,
        timeRangeValue: "",
        theme: "",
        columns: [
          '09:30 - 10:00',
          '10:00 - 10:30',
          '10:30 - 11:00',
          '11:00 - 11:30',
          '11:30 - 12:00',
          '13:00 - 13:30',
          '13:30 - 14:00',
          "14:00 - 14:30",
          '14:30 - 15:00',
          '15:00 - 15:30'
        ]
      }
    },
    computed: {
      ...mapGetters(['subjectType', 'exhibitionId'])
    },
    created() {
      this.$Toast.loading({
        duration: 5000,
        message: '加载中...',
        forbidClick: true,
      })

      this.getExhibition()
      this.getExhibitor()
    },
    methods: {
      onSend() {
        this.$router.push({
          path: '/invitation/sendResult'
        })
        this.validate().then(valid => {
          if (valid) {
            console.log(valid)
          }
        })
      },
      getExhibition() {
        this.$http.getExhibition({ exhibitionId: this.exhibitionId }).then(res => {
          console.log(res)
          if (res.code === 1000) {
            const data = res.data
            if (data.startTime) {
              const { year, month, day } = this.getYearsMonthDays(data.startTime)
              this.minDate = new Date(year, month, day)
              this.currentDate = new Date(year, month, day)
              // this.dateValue = this.$dayjs(this.currentDate).format("YYYY-MM-DD")
            }
            if (data.endTime) {
              const { year, month, day } = this.getYearsMonthDays(data.endTime)
              this.maxDate = new Date(year, month, day)
            }
          }
        })
      },
      getExhibitor() {
        this.$http.getExhibitorDetails({ id: this.exhibitorId }).then(res => {
          if (res.code === 1000) {
            this.exhibitorInfo = res.data
            this.$Toast.clear()
          }
        })
      },
      onChange(index) {
        this.currentIndex = index
      },
      onDateClick() {
        this.showDatePicker = true
      },
      onPickerClick() {
        this.showPicker = true
      },
      onCancel() {
        this.showDatePicker = false;
      },
      onPickerCancel() {
        this.showPicker = false
      },
      onConfirm(value) {
        this.dateValue = this.$dayjs(value).format("YYYY-MM-DD")
        this.showDatePicker = false
      },
      onPickerConfirm(value, index) {
        this.timeRangeValue = value
        this.showPicker = false
      },
      formatter(type, val) {
        if (type === 'year') {
          return `${val}年`;
        } else if (type === 'month') {
          return `${val}月`;
        } else if (type === "day") {
          return `${val}日`
        }
        return val
      },
      onInput(e) {
        this.theme = e.target.value.replace(/^\s+/, '')
      },
      validate() {
        return new Promise(resolve => {
          if (this.currentIndex == undefined) {
            this.$Toast("请选择洽谈方式")
            return resolve(false)
          }

          if (!this.dateValue) {
            this.$Toast("请选择洽谈日期")
            return resolve(false)
          }

          if (!this.timeRangeValue) {
            this.$Toast("请选择洽谈时间")
            return resolve(false)
          }

          if (!this.theme) {
            this.$Toast("请输入洽谈主题")
            return resolve(false)
          }

          resolve(true)
        })
      },
      getYearsMonthDays(timestamp) {
        const date = this.$dayjs(timestamp)
        return {
          year: date.year(),
          month: date.month(),
          day: date.date()
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .invitation-field-item {
    padding: 12px;
    background: #ffffff;
    border-radius: 12px;
    margin-bottom: 16px;
    .invitation-title {
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      .require {
        font-size: 14px;
        color: red;
        font-weight: bold;
        margin-right: 2px;
      }
    }
    .invitation-exhibitor-info {
      width: 100%;
      display: flex;
      .left {
        width: 70px;
        height: 70px;
        .img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .right {
        flex: 1;
        padding-left: 16px;
        .exhibitor-content {
          padding-top: 6px;
          .exhibitor-name {
            font-weight: 600;
            font-size: 15px;
            color: #333333;
          }
          .site {
            margin-top: 8px;
            font-weight: 500;
            font-size: 13px;
            color: #666666;
            word-break: break-word;
          }
          .contact {
            margin-top: 6px;
            .name {
              font-weight: 500;
              font-size: 13px;
              color: #666666;
            }
            .post {
              font-weight: 500;
              font-size: 13px;
              color: #666666;
              margin-left: 8px;
            }
          }
        }
      }
    }
    .invitation-field-content {
      margin-top: 12px;
      .invite-field {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        &:last-child {
          margin-bottom: 0;
        }
        .field-label {
          font-size: 14px;
          flex: 1;
          color: rgba(0, 0, 0, .8);
        }
        .field-radio {
          width: 16px;
          height: 16px;
          border: 1px solid #BFBFBF;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          position: relative;
          &::after {
            content: "";
            width: 8px;
            height: 8px;
            border-radius: 50%;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            background: #ffffff;
          }
          &.active {
            border: 1px solid #EB592B;
            &::after {
              background: #EB592B;
              border: 1px solid #EB592B;
            }
          }
        }
      }
    }
  }

  .invitation-date {
    display: flex;
    .invitation-date-item {
      flex: 1;
      &:nth-of-type(odd) {
        padding-right: 6px;
      }
      &:nth-of-type(even) {
        padding-left: 6px;
      }
      .picker-inner {
        height: 32px;
        border: 1px solid #D9D9D9;
        padding-left: 8px;
        padding-right: 4px;
        box-sizing: border-box;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .placeholder {
          font-size: 14px;
          color: #cecece;
        }
        .date-value {
          font-size: 14px;
          color: #333333;
        }
        .iconfont {
          font-size: 15px;
          margin-right: 4px;
          color: #948f8f;
        }
      }
    }
  }


  .invitation-send {
    max-width: 560px;
    min-height: 100vh;
    background: #F5F5F5;
    margin: 0 auto;
  }
  .invitation-send-content {
    padding: 12px 12px 100px;
  }

  .textarea {
    display: block;
    width: 100%;
    padding: 2px;
    box-sizing: border-box;
    resize: none;
    border: none;
    background: #F5F5F5;
    padding-left: 8px;
    padding-top: 8px;
    border-radius: 8px;
    font-size: 14px;
    &::placeholder {
      color: #cecece;
      font-size: 14px;
    }
  }
  

  .send-section {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 12px 16px 30px;
    box-sizing: border-box;
    background: #ffffff;
    .send-button {
      width: 100%;
      padding: 10px 24px;
      box-sizing: border-box;
      background: #EB592B;
      font-weight: 600;
      color: #ffffff;
      margin: 0 auto;
      text-align: center;
      border-radius: 26px;
      &.success {
        background: #0e813b;
      }
    }
  }

  .tip-section {
    .tip-title {
      font-size: 12px;
      font-weight: 500;
      color: #666666;
      margin-bottom: 6px;
    }
    .tip-item {
      font-size: 12px;
      font-weight: 400;
      color: #666666;
      margin-top: 0;
      margin-bottom: 6px;
    }
  }

  .text-align-right {
    text-align: right;
  }
  .margin-bottom-4 {
    margin-bottom: 4px;
  }
  .margin-bottom-0 {
    margin-bottom: 0;
  }
  .picker-title {
    font-size: 14px;
    color: rgba(0, 0, 0, .5);
  }
</style>
